import { Button, Card, CardActions, CardContent, CardMedia, Typography } from '@mui/material';
import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import backgroundTile from '../assets/background-tile.svg';

export interface ActionCardProps {
  actionText: string;
  avatar: ReactNode;
  handleClick?: (open: boolean) => void;
  text: string;
  title: string;
  to: string;
}

const ActionCard = ({ actionText, avatar, handleClick, text, title, to }: ActionCardProps) => (
  <Card
    component={Link}
    onClick={() => handleClick && handleClick(true)}
    to={to}
    variant="elevation"
    sx={{ minWidth: 260, maxWidth: { xs: 'inherit', sm: 260 }, textDecoration: 'none' }}
  >
    <CardMedia
      sx={{ height: 197, display: { xs: 'none', sm: 'inherit' }, position: 'relative' }}
      image={backgroundTile}
      title={title}
    >
      {avatar}
    </CardMedia>

    <CardContent sx={{ minHeight: 160 }}>
      <Typography component="h1" gutterBottom variant="h5">
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {text}
      </Typography>
    </CardContent>
    <CardActions
      sx={{
        justifyContent: 'flex-end',
      }}
    >
      <Button type="button">{actionText.toLocaleUpperCase()}</Button>
    </CardActions>
  </Card>
);

export default ActionCard;
